import { Button } from '../../Button/Button';
import './Popup.scss';
import { PopupMessage } from '../../../shared/types/types';
import { XClose } from 'src/icons/XClose';
import { AlertIcon } from 'src/icons/AlertIcon';

export interface PopupProps {
  popupId: string;
  popupMessage: PopupMessage;
  onClosePopup: (id: string) => void;
  style: React.CSSProperties;
}

const Popup = ({
  popupId,
  popupMessage,
  onClosePopup,
  style,
}: PopupProps) => {
  const handleCloseClick = () => {
    onClosePopup(popupId);
  };
  return (
    <div className="popup-container" style={style}>
      <div className="popup-parent">
        <div className="alertSection">
          <div className="alertIcon">
            <AlertIcon height={35} width={35} />
          </div>
        </div>
        <div className="textSection">
          <div className="popup-header">
            <div className="header-text">
              Data {popupMessage.header} Failed
            </div>
          </div>
          <span className="popup-body-text">
            {popupMessage.message}
          </span>
        </div>
        <div className="buttonSection">
          <Button
            className="botton-close"
            icon={<XClose height={30} width={30} />}
            iconPlacement="right"
            onClick={handleCloseClick}
          ></Button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
